import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import RegisterPage from './components/Register';
import LoginPage from './components/Login';
import ForgotPasswordPage from './components/ForgotPassword';
import UpdatePassword from './components/UpdatePassword'
import VerifyEmail from './components/VerifyEmail';
import Action from './components/Action';
import Dashboard from './routes/Dashboard.enhancer';
import ProjectMain from './routes/ProjectSetup/ProjectMain.enhancer';
import Task from './components/Tasks/Task.enhancer';
import WorkerSubTaskDetail from './components/Tasks/WorkerSubTaskDetail';
import WorkerSubTaskList from './components/Tasks/WorkerSubTaskList.enhancer';
import CyclesContainer from './components/Cycles/CyclesContainer.enhancer';
import Documents from './components/Documents/Documents';
import Team from './components/Team/Team';
import TasksDashboard from './components/Tasks/TasksDashboard';
import * as routes from './routes/routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { auth, storage } from './firebase';
import ProtectedRoutes from './routes/ProtectedRoutes';
import TitleBar from './components/common/HeaderBar'
import LoadingProgress from './components/common/LoadingProgress';
import { createMuiTheme } from '@material-ui/core/styles';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { loadCSS } from 'fg-loadcss/src/loadCSS';
import Test from './routes/Test';
import { db } from './firebase/firebase';
import { MAIN_COLOR } from './firebase-config';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: MAIN_COLOR,
    },
    secondary: {
      main: '#1a1817',
    },
  },
  typography: {
    "fontFamily": '-apple-system,system-ui,BlinkMacSystemFont,' + "'Roboto', sans-serif",
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500
  },
  overrides: {
    MuiTab: {
      wrapper: {
        display: 'flex',
        flexDirection: 'row'
      }
    },
  },
});
class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      authenticated: false,
      currentUser: null
    };
  }

  componentWillMount() {
    loadCSS(
      'https://use.fontawesome.com/releases/v5.1.0/css/all.css',
      document.querySelector('#insertion-point-jss'),
    );
    auth.getUser(user => {
      if (user) {
        this.setState({
          authenticated: true,
          currentUser: user,
          loading: false
        });
      } else {
        this.setState({
          authenticated: false,
          currentUser: null,
          loading: false
        });
      }
    });
  }

  componentWillUnmount() {
    db.ref('subTasks').off();
    db.ref('cycles').off();
  }

  handleLogout = () => {
    auth.doSignOut().then(() => {
      this.setState({
        authenticated: false,
        currentUser: null,
        loading: false
      });
    }, (error) => {
      console.error('Sign Out Error', error);
    });
  };
  handleUpload = (accepted) => {
    storage.uploadDoc(this.state.currentUser, accepted[0])
    // .then(() => {
    //   //treba nekako da okine rerender, problem je sto mu se samo prvi put promeni state
    // });
  };

  render() {
    const { authenticated, loading, currentUser } = this.state;
    if (loading) {
      return <LoadingProgress />
    }

    let username = '';
    let imgURL = null;
    let email = '';
    if (currentUser) {
      username = currentUser.email;
      imgURL = currentUser.photoURL;
      email = currentUser.email
    }

    return (
      <React.Fragment>
        <MuiThemeProvider theme={theme}>
          <Router>
            <div>
              <TitleBar
                username={username}
                onLogout={this.handleLogout}
                imgURL={imgURL}
                email={email}
                onDropPicture={this.handleUpload} />
              <Route exact path={routes.REGISTER} component={RegisterPage} />
              <Route exact path={routes.LOGIN} component={LoginPage} />
              <Route exact path={routes.FORGOT_PASSWORD} component={ForgotPasswordPage} />
              <Route exact path={routes.PASSWORD_RESET} component={UpdatePassword} />
              <Route exact path={routes.VERIFY_EMAIL} component={VerifyEmail} />
              <Route path="/action" component={Action} />
              <ProtectedRoutes exact path={routes.PROJECT_CYCLES} component={CyclesContainer} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.DASHBOARD} component={Dashboard} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.PROJECT_SETUP} component={ProjectMain} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.WORKER_TASK_LIST} component={WorkerSubTaskList} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.WORKER_TASK_DETAIL} component={WorkerSubTaskDetail} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.CYCLE_TASK} component={Task} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.DOCUMENTS} component={Documents} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.TEAM} component={Team} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.TASKS} component={TasksDashboard} authenticated={authenticated} user={currentUser} />
              <ProtectedRoutes exact path={routes.TEST} component={Test} authenticated={authenticated} user={currentUser} />
              {currentUser && currentUser.emailVerified &&
                window.location.pathname === '/' ?
                <Switch>
                  <Redirect exact from='/' to="/dashboard" />
                </Switch>
                : null
              }
              <ToastContainer />
            </div>
          </Router>
        </MuiThemeProvider>
      </React.Fragment>
    )
  }
}

export default App;
//1/jywyS7TZHzZ-RHXiUz1qwm6yC_MBpgn2W3tPj1uHMzM



// WEBPACK FOOTER //
// ./src/App.js